import API from "./api"

export default function useRemoveDealComparables({ deal, topic }) {
  const path =
    topic === undefined
      ? `deals/${deal.id}/comparables/deals`
      : `deals/${deal.id}/comparables/topics/${topic.id}/records`

  return async (comparables) => {
    const removePromises = comparables.map((comparable) =>
      API.delete(`${path}/${comparable.id}`)
    )

    await Promise.all(removePromises)
  }
}
